<template>
    <div
        class="o-t-transport-item"
        :style="styles"
        @click="changeTransportItem"
    >
        <div class="o-t-transport-item__icon">
            <img
                :alt="$t('ui.terminal.transport_item_icon')"
                :src="item.parentObject.files.icon"
            >
        </div>
        <template
            v-if="isShowNameWithCategoryName"
        >
            <div 
                class="o-t-transport-item__name" 
            >
                {{ item.categoryName }}
            </div>
            <div class="o-t-transport-item__number">
                {{routeSymbol}}{{item.routeId}}
            </div>
        </template>
        <template v-else>
            <div class="o-t-transport-item__number">
                {{item.routeId}}
            </div>
            <div class="o-t-transport-item__name">
                {{item.name}}
            </div>
        </template>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    name: 'OTTransportItem',
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        styles() {
            return this.getMapConfigProp('components.OTTransportItem.styles') || {};
        },
        params() {
            return this.getMapConfigProp('components.OTTransportItem.params') || {};
        },
        isShowNameWithCategoryName() {
            return this.params.is_show_name_with_category_name
        },
        routeSymbol() {
            return this.params.route_symbol || ''
        }
    },
    methods: {
        changeTransportItem() {
            this.$emit('changeTransportItem', this.item);
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />